// Read again on demand only, not on a focus, as on the return from a PDF:
// for a slow or rate limited source, as Pennylane
export const ON_DEMAND_QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  retry: 1,
};
